import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "order-totals" };
const _hoisted_2 = { class: "order-totals__total" };
const _hoisted_3 = {
    key: 0,
    class: "order-totals__taxes"
};
const _hoisted_4 = {
    key: 1,
    class: "order-totals__taxes"
};
import Price from "./Price.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderTotal',
    props: {
        totals: {},
        currency: {},
        taxIncluded: { type: Boolean }
    },
    setup(__props) {
        function formatRate(rate) {
            return (parseFloat(rate) * 100) + '%';
        }
        function formatAmount(amount) {
            return "" + parseFloat(amount);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createTextVNode(_toDisplayString(_ctx.$t('orders.order_total')) + " ", 1),
                    _createVNode(Price, {
                        currency: __props.currency,
                        amount: __props.taxIncluded ? __props.totals.orderTotal : __props.totals.netOrderTotal
                    }, null, 8, ["currency", "amount"])
                ]),
                _cache[0] || (_cache[0] = _createTextVNode()),
                (__props.taxIncluded && __props.totals.includedTaxes)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.totals.includedTaxes, (tax, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "order-totals__tax"
                            }, [
                                _createTextVNode(_toDisplayString(_ctx.$t('orders.tax_incl', { name: tax.name, rate: tax.rate })) + " ", 1),
                                _createVNode(Price, {
                                    currency: __props.currency,
                                    amount: tax.amount
                                }, null, 8, ["currency", "amount"])
                            ]));
                        }), 128))
                    ]))
                    : (__props.taxIncluded && __props.totals.taxes)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.totals.taxes, (tax, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "order-totals__tax"
                                }, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('orders.tax_incl', { name: _ctx.$trans(tax.name), rate: formatRate(tax.rate) })) + " ", 1),
                                    _createVNode(Price, {
                                        currency: __props.currency,
                                        amount: formatAmount(tax.amount)
                                    }, null, 8, ["currency", "amount"])
                                ]));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true)
            ]));
        };
    }
});
